<section class="px-4 websites_managment">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center">
    <div class="page_header d-flex">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 translate class="m-0 page_header_title">Mission / Vission</h1>
    </div>
    <div class="mv-header-container">
      <button
        translate
        mat-raised-button
        color="primary"
        [disabled]="VisionMissionData.length >= 2"
        (click)="openUploadDialog()"
        class="px-5"
      >
        + Add Mission/Vission
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="table-container list-container mt-3 p-0">
    <ng-container *ngIf="VisionMissionData?.length === 0; else cardsBlock">
      <div
        class="empty-data d-flex flex-column justify-content-center align-items-center py-5 my-5 text-muted"
      >
        <mat-icon class="empty-icon mb-3" aria-hidden="false">inbox</mat-icon>
        <p class="fs-5 fw-medium m-0" translate>
          No Mission or Vision added yet
        </p>
        <p class="text-muted small mt-1">
          Click the button above to get started.
        </p>
      </div>
    </ng-container>

    <ng-template #cardsBlock>
      <div class="row g-4 p-3">
        <div
          class="col-12 col-md-6 col-lg-6"
          *ngFor="let element of VisionMissionData"
        >
          <mat-card
            class="mv-card h-100 shadow-sm border-0 overflow-hidden"
            matTooltip="{{ element.content_type }}"
          >
            <!-- Image -->
            <div class="mv-image-container">
              <img
                [src]="imagePath + '/' + element.image_url"
                alt="{{ element.content_type }} image"
                class="w-100 h-100 object-fit-contain"
                loading="lazy"
                (error)="handleImageError($event)"
              />
            </div>

            <!-- Content -->
            <mat-card-header class="px-4 pt-4 pb-2 border-bottom">
              <mat-card-title
                class="mv-title d-flex align-items-center justify-content-between w-100"
              >
                <span class="fw-semibold">{{ element.content_type }}</span>
                <button
                  mat-icon-button
                  color="primary"
                  class="ms-2"
                  matTooltip="Edit {{ element.content_type }}"
                  (click)="
                    EditopenUploadDialog(element.content_type, element);
                    $event.stopPropagation()
                  "
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </mat-card-title>
            </mat-card-header>

            <mat-card-content class="p-4">
              <p class="text-body-secondary mb-0 line-clamp-4">
                {{ element.content }}
              </p>
            </mat-card-content>

            <!-- Optional: actions at bottom -->
            <!-- <mat-card-actions align="end" class="px-4 pb-3 pt-1">
            <button mat-icon-button color="warn" (click)="deleteItem(element.content_type, element.id)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </mat-card-actions> -->
          </mat-card>
        </div>
      </div>
    </ng-template>
  </div>
</section>
